import { render, staticRenderFns } from "./AddressInput.vue?vue&type=template&id=189c914d&scoped=true"
import script from "./AddressInput.vue?vue&type=script&lang=js"
export * from "./AddressInput.vue?vue&type=script&lang=js"
import style0 from "./AddressInput.vue?vue&type=style&index=0&id=189c914d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189c914d",
  null
  
)

export default component.exports